module.exports = __webpack_public_path__ + "static/media/geneva-digital-trophy_cut.92e503b5.png";